import { z } from 'zod';

export const sectraVersionToApiVersion: Record<string, string> = {
  '4.0': '1.8',
  '4.1': '1.9',
  '4.2': '1.10',
};

export const integrationVariables = z.discriminatedUnion('INTEGRATOR', [
  z.object({
    INTEGRATOR: z.literal('sectra').describe('The name of the integrator'),
    SECTRA_API_VERSION: z.string().describe('The API version of the Sectra integration'),
    SECTRA_CLIENT_ID: z.string().describe('The client ID for the Sectra integration'),
    SECTRA_CLIENT_SECRET: z.string().describe('The client secret for the Sectra integration'),
  }),
]);

export type IntegrationVariablesType = z.infer<typeof integrationVariables>;

export const sectraApiVersionToMessage: Record<string, string> = {
  '1.10': 'COMMON.INTEGRATION.SECTRA.QC-MESSAGE',
};

export const SectraIntegrationInputCredentials = z.object({
  v: z.string().optional().describe('The version of the integration'),
  id: z.string().optional().describe('The id of the integration'),
  sct: z.string().optional().describe('The secret of the integration'),
});

export type SectraIntegrationInputCredentialsType = z.infer<typeof SectraIntegrationInputCredentials>;

export const SectraIntegrationOutputCredentials = SectraIntegrationInputCredentials.transform((data) => ({
  version: data.v,
  integrationId: data.id,
  integrationSecret: data.sct,
}));

export const IntegrationInputCredentials = z
  .object({
    sectra: SectraIntegrationInputCredentials,
  })
  .partial();

export type IntegrationInputCredentialsType = z.infer<typeof IntegrationInputCredentials>;

export const IntegrationOutputCredentials = z
  .object({
    sectra: SectraIntegrationOutputCredentials,
  })
  .partial();

export type IntegrationOutputCredentialsType = z.infer<typeof IntegrationOutputCredentials>;

export const TenantIntegrationConfiguration = z.object({
  integrator: z.string().describe('The integration type (FK to integration.integrator)'),
  version: z.string().describe('The integration version (FK to integration.version)'),
});

export const IntegrationConfiguration = z.object({
  images: z.record(
    z.string(),
    z.object({
      name: z.string().describe('The name of the image'),
      tag: z.string().describe('The version of the image'),
      digest: z
        .string()
        .optional()
        .describe('The digest of the image, if this is specified this will used to pull the image'),
    }),
  ),
});

export const Integration = z.object({
  integrator: z.string().describe('The integration type'),
  version: z.string().describe('The integration version'),
  configuration: IntegrationConfiguration,
});

export type IntegrationConfigurationType = z.infer<typeof IntegrationConfiguration>;

export type IntegrationType = z.infer<typeof Integration>;
